<div class="content p-24" id = "content">

    <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2">
                
        <div class="example-viewer-body">
            <div class="example-container">
                <div>
                <fieldset class = "fieldsetstartdatum">
                    <legend>Startdatum:</legend>
                    <button class = "planningfilterbutton" (click)="onToday()" mat-stroked-button>Today</button>
                    <button class = "planningfilterbutton" (click)="onMin1Day()" mat-stroked-button>-1D</button>
                    <button class = "planningfilterbutton" (click)="onMin1Week()" mat-stroked-button>-1W</button>
                     <mat-form-field style ="margin-top:-10px;height:10px;" class = "planningfilterbutton">
                    <input matInput [(ngModel)]="datebegin" name="datebegin" [matDatepicker]="picker" (dateChange)="changeDate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field> 
                    <button class = "planningfilterbutton" (click)="onPlus1Week()"mat-stroked-button>+1W</button>
                    <button class = "planningfilterbutton" (click)="onPlus1Day()"mat-stroked-button>+1D</button>
                </fieldset>      
                <fieldset class = "fieldsetopties" style="width:10%">
                    <legend>Opties:</legend>
                    <mat-form-field style = "height:15px; width:100px;" >
                        <input matInput [(ngModel)]="aantaldagen" (change)="reloadSheduler()" placeholder="Aantal Dagen">
                    </mat-form-field>
                </fieldset> 
            </div>
            <div id='calendar'></div>
            </div>
        </div>
    </div>
</div>
